import { Box, Burger, Group } from '@mantine/core';

import { useNavStore } from '@/store/nav';

import Avatar from './Avatar';
import Language from './Language';

export default () => {
  const { navbarOpened, setNavbarOpened } = useNavStore();

  return (
    <Box h={70} p={'md'} className="backdrop-blur-md bg-white/30" style={{ backgroundColor: 'inherit' }}>
      <Group justify="space-between">
        <Group>
          <Burger
            size={'sm'}
            opened={navbarOpened}
            onClick={() => {
              setNavbarOpened(!navbarOpened);
            }}
          />
        </Group>
        <Group justify="space-between">
          <Language />
          <Avatar />
        </Group>
      </Group>
    </Box>
  );
};
